import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { translation as enCommon } from './local/en/common';
import { translation as frCommon } from './local/fr/common';
import { translation as deCommon } from './local/de/common';
import { translation as daCommon } from './local/da/common';

const resources = {
  en: { translation: enCommon },
  fr: { translation: frCommon },
  de: { translation: deCommon },
  da: { translation: daCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;